/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { clone } from 'underscore';
import classnames from 'classnames';
import Backbone from 'backbone';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import BudgetView from '@bingads-webui-campaign-legacy/budget/view/budget';
import SharedBudgetView from '@bingads-webui-campaign-legacy/shared-budget/view/shared-budget-switch-editor';
import '@bingads-webui-campaign/ko-stop-binding';
import PageContext from '@bingads-webui-static-legacy/page-context';
import { getStyles } from './style';

export const LegacySharedBudget = React.memo(({
  id,
  className,
  campaignId,
  budget,
  onChange,
  i18n,
  validationDailyMinBudget,
  hideBudgetMinRecommendation,
  noApplyBudgetFromSharedLibrary,
}) => {
  const view = useRef();
  const viewListener = useMemo(() => clone(Backbone.Events), []);
  let container;

  useEffect(() => {
    const budgetFactory = SharedBudgetView.newFactory(BudgetView);
    const showBudgetMinRecommend = campaignId !== undefined && !hideBudgetMinRecommendation;
    const minimumBudget = budget ? budget.Amount * 0.5 : undefined;

    view.current = budgetFactory({
      withRealTimeUpdates: true,
      model: budget,
      campaignId,
      isForVNext: true,
      hideDailyBudgetOptions: false,
      showBudgetMinRecommend,
      currencySymbol: i18n.getCurrencySymbol(PageContext.AccountCurrencyCode),
      minimumBudget,
      validationDailyMinBudget,
      showInitialUiBlocker: false,
      noApplyBudgetFromSharedLibrary,
      showNoSharedBudgetLink: true,
    });

    view.current.render();
    view.current.$el.appendTo(container);

    return () => {
      view.current.remove();
    };
  }, []);

  useEffect(() => {
    viewListener.listenTo(view.current, 'change', onChange);

    return () => viewListener.stopListening(view.current);
  }, [onChange, viewListener]);

  const classes = useDefaultStyles(getStyles);

  return (
    <div
      id={id}
      className={classnames(className, classes.budgetContainer)}
    >
      <div ref={(ref) => { container = ref; }} />
    </div>
  );
});

LegacySharedBudget.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  campaignId: PropTypes.string,
  budget: PropTypes.shape({
    Amount: PropTypes.number,
  }),
  onChange: PropTypes.func.isRequired,
  i18n: PropTypes.shape({ getCurrencySymbol: PropTypes.func.isRequired }).isRequired,
  validationDailyMinBudget: PropTypes.number,
  hideBudgetMinRecommendation: PropTypes.bool,
  noApplyBudgetFromSharedLibrary: PropTypes.bool,
};

LegacySharedBudget.defaultProps = {
  id: undefined,
  className: undefined,
  budget: undefined,
  campaignId: undefined,
  validationDailyMinBudget: undefined,
  hideBudgetMinRecommendation: false,
  noApplyBudgetFromSharedLibrary: false,
};
